import TagsNav from './tags-nav.vue'
export default TagsNav



// WEBPACK FOOTER //
// ./src/components/main/components/tags-nav/index.js